const type = 'EDITING_ACCOUNT_PARAMETER';

const editingAccountParameter = (payload) => ({
  type,
  payload,
});

export { type };
export default editingAccountParameter;
